export interface IBaseJournalData {
  canAchieve: boolean;
  full: string;
}
export interface IJournalData {
  [key: string]: IBaseJournalData;
}

export const ABBREVIATIONS = [
  "accchemres",
  "acscatal",
  "acscentsci",
  "acscombsci",
  "acsomega",
  "advmater",
  "advsci",
  "advsynthcatal",
  "angewcheminted",
  "asianjorgchem",
  "chemasianj",
  "chemcommun",
  "chemeurj",
  "chemistryselect",
  "chemrev",
  "chemsci",
  "chemsocrev",
  "chemsuschem",
  "chinjchem",
  "eurjorgchem",
  "greenchem",
  "jamchemsoc",
  "jmedchem",
  "jnatprod",
  "jorgchem",
  "natchem",
  "natcommun",
  "natlscirev",
  "natmethods",
  "natprodrep",
  "natrevchem",
  "nature",
  "organometallics",
  "orgbiomolchem",
  "orgchemfront",
  "orglett",
  "orgprocessresdev",
  "pnas",
  "rscadv",
  "sciadv",
  "scibull",
  "science",
  "scirep",
  "synlett",
  "synthesis",
  "tetrahedron",
  "tetrahedronlett",
  "topcurrchem"
];

export const JOURNAL_DATA: IJournalData = {
  accchemres: {
    canAchieve: true,
    full: "Acc. Chem. Res."
  },
  acscatal: {
    canAchieve: true,
    full: "ACS Catal."
  },
  acscentsci: {
    canAchieve: true,
    full: "ACS Cent. Sci."
  },
  acscombsci: {
    canAchieve: true,
    full: "ACS Comb. Sci."
  },
  acsomega: {
    canAchieve: true,
    full: "ACS Omega"
  },
  advmater: {
    canAchieve: true,
    full: "Adv. Mater."
  },
  advsci: {
    canAchieve: true,
    full: "Adv. Sci."
  },
  advsynthcatal: {
    canAchieve: false,
    full: "Adv. Synth. Catal."
  },
  angewcheminted: {
    canAchieve: true,
    full: "Angew. Chem. Int. Ed."
  },
  asianjorgchem: {
    canAchieve: false,
    full: "Asian J. Org. Chem."
  },
  chemasianj: {
    canAchieve: false,
    full: "Chem. Asian J."
  },
  chemcommun: {
    canAchieve: false,
    full: "Chem. Commun."
  },
  chemeurj: {
    canAchieve: false,
    full: "Chem. Eur. J."
  },
  chemistryselect: {
    canAchieve: false,
    full: "Chemistry Select"
  },
  chemrev: {
    canAchieve: true,
    full: "Chem. Rev."
  },
  chemsci: {
    canAchieve: true,
    full: "Chem. Sci."
  },
  chemsocrev: {
    canAchieve: true,
    full: "Chem. Soc. Rev."
  },
  chemsuschem: {
    canAchieve: false,
    full: "Chem. Sus. Chem."
  },
  chinjchem: {
    canAchieve: false,
    full: "Chin. J. Chem ."
  },
  eurjorgchem: {
    canAchieve: false,
    full: "Eur. J. Org. Chem."
  },
  greenchem: {
    canAchieve: false,
    full: "Green Chem."
  },
  jamchemsoc: {
    canAchieve: true,
    full: "J. Am. Chem. Soc."
  },
  jmedchem: {
    canAchieve: true,
    full: "J. Med. Chem."
  },
  jnatprod: {
    canAchieve: true,
    full: "J. Nat. Prod."
  },
  jorgchem: {
    canAchieve: true,
    full: "J. Org. Chem."
  },
  natchem: {
    canAchieve: false,
    full: "Nat. Chem."
  },
  natcommun: {
    canAchieve: true,
    full: "Nat. Commun."
  },
  natlscirev: {
    canAchieve: false,
    full: "Natl. Sci. Rev."
  },
  natmethods: {
    canAchieve: false,
    full: "Nat. Methods"
  },
  natprodrep: {
    canAchieve: false,
    full: "Nat. Prod. Rep."
  },
  natrevchem: {
    canAchieve: false,
    full: "Nat. Rev. Chem."
  },
  nature: {
    canAchieve: false,
    full: "Nature"
  },
  organometallics: {
    canAchieve: true,
    full: "Organometallics"
  },
  orgbiomolchem: {
    canAchieve: false,
    full: "Org. Biomol. Chem."
  },
  orgchemfront: {
    canAchieve: false,
    full: "Org. Chem. Front."
  },
  orglett: {
    canAchieve: true,
    full: "Org. Lett."
  },
  orgprocessresdev: {
    canAchieve: false,
    full: "Org. Process Res. Dev."
  },
  pnas: {
    canAchieve: false,
    full: "PNAS"
  },
  rscadv: {
    canAchieve: false,
    full: "Rsc. Adv."
  },
  sciadv: {
    canAchieve: false,
    full: "Sci. Adv."
  },
  scibull: {
    canAchieve: false,
    full: "Sci. Bull."
  },
  science: {
    canAchieve: false,
    full: "Science"
  },
  scirep: {
    canAchieve: false,
    full: "Sci. Rep."
  },
  synlett: {
    canAchieve: false,
    full: "Synlett"
  },
  synthesis: {
    canAchieve: false,
    full: "Synthesis"
  },
  tetrahedron: {
    canAchieve: true,
    full: "Tetrahedron"
  },
  tetrahedronlett: {
    canAchieve: true,
    full: "Tetrahedron Lett."
  },
  topcurrchem: {
    canAchieve: false,
    full: "Top. Curr. Chem."
  }
};

export const ABBREVIATIONS_ALL = [
  "accchemres",
  "achmodelschem",
  "acimaterj",
  "acsapplmaterinterfaces",
  "acsbiomaterscieng",
  "acscatal",
  "acscentsci",
  "acschembiol",
  "acschemneurosci",
  "acscombsci",
  "acsearthspacechem",
  "acsenergylett",
  "acsinfectdis",
  "acsmacrolett",
  "acsmedchemlett",
  "acsnano",
  "acsomega",
  "acsphotonics",
  "acssens",
  "acssustainablechemeng",
  "acssympser",
  "acssynthbiol",
  "actabiochimpol",
  "actabiomater",
  "actabiotechnol",
  "actachemscand",
  "actachimsinica",
  "actacrystallografoundadv",
  "actacrystallogrsectafoundcrystallogr",
  "actacrystallogrsectbstructsci",
  "actacrystallogrsectccryststructcommun",
  "actacrystallogrsectdbiolcrystallogr",
  "actahydrochhydrob",
  "actamater",
  "actametall",
  "actaphyspola",
  "actaphyspolb",
  "actapolym",
  "actapolytechscandchemtechnolser",
  "adhesage",
  "adsorptscitechnol",
  "advapplmicrobiol",
  "advatmoloptphy",
  "advbiochemengbiotechnol",
  "advcarbohydrchembiochem",
  "advchemphys",
  "advchemser",
  "advchromatogr",
  "advcolloidinterfacesci",
  "advcomposmater",
  "advcryogeng",
  "advelectronmater",
  "advenergymater",
  "advenzymeregul",
  "advenzymolrelatareasmolbiol",
  "adversedrugreacttoxicolrev",
  "advfiltrseptechnol",
  "advfunctmater",
  "advhealthcaremater",
  "advheterocyclchem",
  "advmassspectrom",
  "advmater",
  "advmaterinterfaces",
  "advmateroptelectron",
  "advmaterprocesses",
  "advmaterres",
  "advoptmater",
  "advorganometchem",
  "advphysorgchem",
  "advpolymsci",
  "advpolymtech",
  "advpowdermetallpartmater",
  "advpowdertechnol",
  "advproteinchem",
  "advquantumchem",
  "advsci",
  "advsecondmessengerphosphoproteinres",
  "advspaceres",
  "advsynthcatal",
  "advxrayanal",
  "aerosolscitechnol",
  "alchej",
  "alchesympser",
  "amceramsocbull",
  "amindhygassocj",
  "amjrespircellmolbiol",
  "amlab",
  "ammineral",
  "ammoniaplantsafrelatfacil",
  "analbioanalchem",
  "analbiochem",
  "analchem",
  "analchim",
  "analchimacta",
  "analcommun",
  "anallett",
  "analmethods",
  "analsci",
  "analyst",
  "anasocquimargent",
  "angewcheminted",
  "angewmakromolchem",
  "annchimrome",
  "annchimscimat",
  "annclinbiochem",
  "annnyacadsci",
  "annurepmedchem",
  "annurevanalchem",
  "annurevbiochem",
  "annurevbiophysbiomolstruct",
  "annurevcelldevbiol",
  "annurevenergyenv",
  "annurevenvironresour",
  "annurevfoodscitechnol",
  "annurevmaterres",
  "annurevmatersci",
  "annurevpharmacooltoxicol",
  "annurevphyschem",
  "anquim",
  "anticancerdrugdes",
  "anticancerres",
  "antimicrobagentschemother",
  "antisensenucleicaciddrugdev",
  "antiviralchemchemother",
  "appitaj",
  "applbiochembiotechnol",
  "applcatala",
  "applcatalagen",
  "applcatalb",
  "applcatalbenviron",
  "applclaysci",
  "applcomposmater",
  "applenergy",
  "applenvironmicrobiol",
  "applmagnreson",
  "applmicrobiolbiotechnol",
  "applopt",
  "applorganometchem",
  "applphysa",
  "applphysb",
  "applphyslett",
  "applradiatisot",
  "applscires",
  "applspectrosc",
  "applsupercond",
  "applsurfsci",
  "applthermeng",
  "aquattoxicol",
  "arabjchem",
  "archbiochembiophys",
  "archenvironcontamtoxicol",
  "archenvironhealth",
  "archinsectbiochemphysiol",
  "archmicrobiol",
  "archpharm",
  "archpharmacalres",
  "archphysiolbiochem",
  "archtoxicol",
  "archvirol",
  "artifcellsbloodsubstituesimmobilizationbiotechnol",
  "arzneimforsch",
  "asianjchem",
  "asianjorgchem",
  "asianjspectro",
  "astmspectechpubl",
  "astronastrophys",
  "astronj",
  "astrophysj",
  "atdatanucldatatables",
  "atenerg",
  "atmosenviron",
  "atomizationsprays",
  "austjchem",
  "behavpharmacol",
  "ber",
  "berbunsengesphyschem",
  "biocatalbiotransform",
  "biochemarch",
  "biochembiophysrescommun",
  "biochemcellbiol",
  "biochemengj",
  "biochemgenet",
  "biochemistry",
  "biochemj",
  "biochemmedmetabbiol",
  "biochemmolbiolint",
  "biochemmolmed",
  "biochempharmacol",
  "biochemsocsymp",
  "biochemsoctrans",
  "biochemsystecol",
  "biochimbiophysacta",
  "bioconjugatechem",
  "bioelectrochembioenerg",
  "bioelectrochemistry",
  "biogamines",
  "biolchem",
  "biolchemhoppeseyler",
  "biolmembr",
  "biolpharmbull",
  "bioltraceelemres",
  "biomacromolecules",
  "biomassbioenergy",
  "biomaterials",
  "biomatersci",
  "biomedchromatogr",
  "biomedmatereng",
  "biomedmicrodevices",
  "biomoleng",
  "bioorganchem",
  "bioorgchem",
  "bioorgkhim",
  "bioorgmedchem",
  "bioorgmedchemlett",
  "biopharmdrugdispos",
  "biophyschem",
  "biophysj",
  "bioprocesseng",
  "bioremj",
  "bioresourcetechnol",
  "bioresourtechnol",
  "bioscibiotechnolbiochem",
  "bioscirep",
  "biosensbioelectron",
  "biotechhistochem",
  "biotechnoladv",
  "biotechnolapplbiochem",
  "biotechnolbioeng",
  "biotechnollett",
  "biotechnolprogr",
  "biotechnoltech",
  "bolsocchilquim",
  "brceramtrans",
  "brcorrosj",
  "brennstwarmekraft",
  "brjpharmacol",
  "bullchemsocjpn",
  "bullelectrochem",
  "bullenvironcontamtoxicol",
  "bullhistchem",
  "bullkoreanchemsoc",
  "bullmatersci",
  "bullpolacadscichem",
  "bullsocchimbelg",
  "bullsocchimfr",
  "cahinftechrevmetall",
  "calphad",
  "canceramq",
  "canjanalscispectros",
  "canjbiochem",
  "canjchem",
  "canjchemeng",
  "canjmicrobiol",
  "canjphys",
  "canjphysiolpharmacol",
  "canmetallq",
  "canmineral",
  "canminj",
  "carbohydrchem",
  "carbohydrlett",
  "carbohydrpolym",
  "carbohydrres",
  "carbon",
  "catalcommun",
  "catallett",
  "catalrevscieng",
  "catalscitechnol",
  "cataltoday",
  "catrevscieng",
  "cellbiochemfunct",
  "cellchembio",
  "cellphysiolbiochem",
  "cellpolym",
  "cellulchemtechnol",
  "cemconcrres",
  "ceramint",
  "ceramsilik",
  "ceramtrans",
  "cerealchem",
  "chemanalwarsaw",
  "chemanlagenverfahren",
  "chemasianj",
  "chember",
  "chemberrecl",
  "chembiochem",
  "chembiochemengq",
  "chembiodrugdes",
  "chembiolinteract",
  "chembr",
  "chemcatchem",
  "chemcommun",
  "chemeducrespract",
  "chemelectrochem",
  "chemengcommun",
  "chemengj",
  "chemenglondon",
  "chemengnews",
  "chemengnewyork",
  "chemengprocess",
  "chemengprog",
  "chemengresdes",
  "chemengsci",
  "chemengtechnol",
  "chemeurj",
  "chemexpress",
  "chemgeol",
  "chemheterocyclcompd",
  "chemindlondon",
  "chemingtech",
  "chemistryselect",
  "chemlett",
  "chemlisty",
  "chemmater",
  "chemmedchem",
  "chemnatcompd",
  "chemomintelllabsyst",
  "chemosphere",
  "chempapchemzvesti",
  "chempharmbull",
  "chemphys",
  "chemphyscarbon",
  "chemphyslett",
  "chemphyslipids",
  "chempluschem",
  "chemprocess",
  "chemrestoxicol",
  "chemrev",
  "chemsci",
  "chemsenses",
  "chemsocrev",
  "chemspeciationbioavailability",
  "chemsuschem",
  "chemtech",
  "chemtechleipzig",
  "chemtechnolfuelsoils",
  "chemunsererzeit",
  "chemvapdeposition",
  "chemweek",
  "chinchemlett",
  "chinjchem",
  "chinjchemeng",
  "chinjnuclphys",
  "chinjpolymsci",
  "chinscibull",
  "chromatogrsciser",
  "cimbull",
  "claysclayminer",
  "clinbiochem",
  "clinchem",
  "clinchimacta",
  "collectczechchemcommun",
  "colloidj",
  "colloidpolymsci",
  "colloidssurfa",
  "colloidssurfb",
  "combustflame",
  "combustscitechnol",
  "commentsinorgchem",
  "compbiochemphysiolaphysiol",
  "compbiochemphysiolbbiochemmolbiol",
  "compbiochemphysiolcpharmacoltoxicol",
  "composeng",
  "compositesparta",
  "compositespartb",
  "compospartaapplscimanuf",
  "composscitechnol",
  "composstruct",
  "comprrevfoodscifoodsaf",
  "computchemeng",
  "computchemoxford",
  "computmatersci",
  "conceptsmagnreson",
  "constrbuildmater",
  "continuummechthermodyn",
  "contribmineralpetrol",
  "coordchemrev",
  "coordinchemrev",
  "corrosrev",
  "corrossci",
  "cracadsciseriiasciterreplanets",
  "cracadsciseriibmecphyschimastron",
  "cracadsciseriicchim",
  "cracadsciseriii",
  "critrevanalchem",
  "critrevbiochemmolbiol",
  "critrevbiotechnol",
  "critrevenvscitechnol",
  "critrevfoodscinutr",
  "critrevsolidstatematersci",
  "critrevtoxicol",
  "croatchemacta",
  "crysteng",
  "crystengcomm",
  "crystgrowthdes",
  "crystrestechnol",
  "curropinbiotechnol",
  "curropinchembiol",
  "curropinchemeng",
  "curropincolloidinterfacesci",
  "curropinenvironsustain",
  "curropinsolidstatematersci",
  "currorgchem",
  "currplantscibiotechnolagric",
  "currtopmembr",
  "daltontrans",
  "dentmater",
  "desalination",
  "diamondfilmstechnol",
  "diamondrelatmater",
  "doklakadnauk",
  "drugchemtoxicol",
  "drugdevindpharm",
  "drugdevres",
  "drugdiscoverytoday",
  "drugdiscovtoday",
  "dryingtechnol",
  "dyespigments",
  "earthplanetscilett",
  "ecoleng",
  "econgeol",
  "ecotoxenvironsafe",
  "ecotoxicolenvironsaf",
  "electroanalysis",
  "electrochemcommun",
  "electrochemsocinterface",
  "electrochemsolidstatelett",
  "electrochimacta",
  "electronlett",
  "emboj",
  "energyenvironsci",
  "energyfuels",
  "energystoragemater",
  "engminj",
  "environcarcinogecotoxicolrev",
  "environgeochemhealth",
  "environgeol",
  "environhealthperspect",
  "environimpactassessrev",
  "environint",
  "environmodelsoftw",
  "environmonitassess",
  "environpollut",
  "environprog",
  "environres",
  "environscinano",
  "environscipolicy",
  "environsciprocessesimpacts",
  "environscitechnol",
  "environscitechnollett",
  "environsciwaterrestechnol",
  "environtechnol",
  "environtoxicolchem",
  "environtoxicolpharmacol",
  "environtoxicolwaterqual",
  "enzymemicrobtechnol",
  "enzymeprotein",
  "erdolandkohleerdgaspetrochem",
  "eurjbiochem",
  "eurjclinchemclinbiochem",
  "eurjinorgchem",
  "eurjmedchem",
  "eurjmineral",
  "eurjorgchem",
  "eurjpharmacol",
  "eurjsolidstateinorgchem",
  "eurmassspectrom",
  "europhyslett",
  "eurpolymj",
  "expfluids",
  "explormingeol",
  "expthermfluidsci",
  "faradaydiscuss",
  "fasebj",
  "fatiguefractengmaterstruct",
  "febslett",
  "femsimmunolmedmicrobiol",
  "femsmicrobiolecol",
  "femsmicrobiollett",
  "femsmicrobiolrev",
  "fettlipid",
  "fieldanalchemtechnol",
  "filtrsep",
  "fizmetmetalloved",
  "flavourfragj",
  "fluidpartsepj",
  "fluidphaseequilib",
  "folddes",
  "foodadditcontam",
  "foodbioproctech",
  "foodbiotechnol",
  "foodchem",
  "foodchemtoxicol",
  "foodcontrol",
  "foodfunct",
  "foodhydrocoll",
  "foodqualprefer",
  "foodresint",
  "foodscitechnolint",
  "freeradicalbiolmed",
  "freeradicalres",
  "freseniusenvironbull",
  "freseniusjanalchem",
  "frontsciser",
  "fuel",
  "fuelprocesstechnol",
  "fuelscitechnolint",
  "fullerenescitechnol",
  "fundamappltoxicol",
  "fusionengdes",
  "fusiontechnol",
  "galvanotechnik",
  "gasseppurif",
  "gazzchimital",
  "gefahrstoffereinhaltluft",
  "genetanalbiomoleng",
  "geochimcosmochimacta",
  "geolgeofiz",
  "geomicrobiolj",
  "glassceram",
  "glassphyschem",
  "glassres",
  "glassscitechnol",
  "glasstechnol",
  "globalbiogeochemcycles",
  "glycobiology",
  "glycoconjugatej",
  "greenchem",
  "handbexppharmacol",
  "hazardwastehazardmater",
  "healthphys",
  "heatmasstransfer",
  "heattreatmet",
  "heivchimacta",
  "heteroatchem",
  "heterocyclcommun",
  "heterogenchemrev",
  "highenergchem",
  "highperformpolym",
  "hightempmaterprocesseslondon",
  "hightempmaterprocessesnewyork",
  "holzrohwerkst",
  "hoppeseylerszphysiolchem",
  "hrcjhighresolutchromatogr",
  "hungjindchem",
  "hydrocarbonprocessinted",
  "hyperfineinteract",
  "inddiamondrev",
  "indengchemfundam",
  "indengchemres",
  "indianjbiochembiophys",
  "indianjchemsecta",
  "indianjchemsectb",
  "indianjchemtechnol",
  "indianjengmatersci",
  "indianjheterocyclchem",
  "indianjpureapplphys",
  "indianjtechnol",
  "ingquim",
  "innovfoodsciemergtechnol",
  "inorgchem",
  "inorgchemcommun",
  "inorgchemfront",
  "inorgchimacta",
  "inorgmater",
  "inorgsynth",
  "insectbiochemmolbiol",
  "instrumscitechnol",
  "intbiodeteriorbiodegrad",
  "intdataserseldatamixturessera",
  "interfacesci",
  "intermetallics",
  "internetjchem",
  "intjadhesadhes",
  "intjbiochem",
  "intjbiochemcellbiol",
  "intjbiolmacromol",
  "intjcastmetres",
  "intjchemkinet",
  "intjenvironanalchem",
  "intjfatigue",
  "intjfoodscitech",
  "intjgreenhgascon",
  "intjheatfluidflow",
  "intjheatmasstransfer",
  "intjhydrogenenergy",
  "intjimmunopharmacol",
  "intjmassspectrom",
  "intjmassspectromionprocesses",
  "intjminerprocess",
  "intjmodphysb",
  "intjmultiphaseflow",
  "intjnumermethodsfluids",
  "intjoncol",
  "intjpeptproteinres",
  "intjpharm",
  "intjplast",
  "intjpolymermater",
  "intjpowdermetall",
  "intjquantumchem",
  "intjradiatbiol",
  "intjrefractmethardmater",
  "intjselfpropaghightempsynth",
  "intjthermophys",
  "intmaterrev",
  "intpolymproc",
  "intrevphyschem",
  "inzchemprocesowa",
  "ironmakingsteelmaking",
  "isijint",
  "isrjchem",
  "jacadnutrdiet",
  "jacs",
  "jadhes",
  "jadhesscitechnol",
  "jadvmater",
  "jaerosolsci",
  "jagricfoodchem",
  "jairwastemanageassoc",
  "jalloyscompd",
  "jamceramsoc",
  "jamchemsoc",
  "jamerchemsoc",
  "jamoilchemsoc",
  "jamsocbrewchem",
  "jamsocmassspectrom",
  "janalapplpyrol",
  "janalapplpyrolysis",
  "janalatspectrom",
  "janalchem",
  "janaltoxicol",
  "jantibiot",
  "jantimicrobchemother",
  "jaoacint",
  "japplbacteriol",
  "japplbiomater",
  "japplcrystallogr",
  "japplelectrochem",
  "japplphycol",
  "japplphys",
  "japplpolymsci",
  "japplspectrosc",
  "jappltoxicol",
  "jautomchem",
  "jbacteriol",
  "jbioactcompatpolym",
  "jbiochem",
  "jbiochembiophmethods",
  "jbiolchem",
  "jbiolinorgchem",
  "jbioluminchemilumin",
  "jbiomaterappl",
  "jbiomaterscipolymed",
  "jbiomedmaterres",
  "jbiomolnmr",
  "jbiomolstructdyn",
  "jbiotechnol",
  "jcanpettechnol",
  "jcarbohydrchem",
  "jcardiovascpharmacol",
  "jcatal",
  "jcellbiochem",
  "jcellbiol",
  "jcellphysiol",
  "jcellsci",
  "jceramsocjpn",
  "jchemcrystallogr",
  "jchemecol",
  "jchemeduc",
  "jchemengdata",
  "jchemengjpn",
  "jcheminfcomputsci",
  "jcheminfmodel",
  "jchemneuroanat",
  "jchemom",
  "jchemphys",
  "jchemressynop",
  "jchemsoc",
  "jchemsocchemcommun",
  "jchemsocdaltontrans",
  "jchemsocfaradaytrans",
  "jchemsocpak",
  "jchemsocperkintrans",
  "jchemtechnolbiotechnol",
  "jchemtheorycomput",
  "jchemthermodyn",
  "jchimphysphyschimbiol",
  "jchinchemsoc",
  "jchininstchemeng",
  "jchromatogr",
  "jchromatogra",
  "jchromatogrb",
  "jchromatogrsci",
  "jcleanprod",
  "jclinendocrinolmetab",
  "jclinmicrobiol",
  "jclustersci",
  "jcoattechnol",
  "jcolloidinterfacesci",
  "jcombchem",
  "jcomposmater",
  "jcompostechres",
  "jcomputaidedmoldes",
  "jcomputchem",
  "jcontamhydrol",
  "jcontrolledrelease",
  "jcoordchem",
  "jcoutil",
  "jcrystgrowth",
  "jdairysci",
  "jdispersionscitechnol",
  "jelastomersplast",
  "jelectroanalchem",
  "jelectrochemsoc",
  "jelectronmater",
  "jelectronmicrosc",
  "jelectronspectroscrelatphenom",
  "jendocrinol",
  "jendotoxinres",
  "jengmatertechnol",
  "jenvironbiol",
  "jenvironeng",
  "jenvironhealth",
  "jenvironmanage",
  "jenvironqual",
  "jenvironradioact",
  "jenvironscihealthparta",
  "jenvironscihealthpartb",
  "jenzyminhib",
  "jessentoilres",
  "jethnopharmacol",
  "jeurceramsoc",
  "jexpbiol",
  "jexpbot",
  "jexposureanalenvironepidemiol",
  "jfermentbioeng",
  "jfiresci",
  "jfluidmech",
  "jfluidseng",
  "jfluorinechem",
  "jfoodbiochem",
  "jfooddruganal",
  "jfoodeng",
  "jfoodprot",
  "jfoodsci",
  "jfunctfoods",
  "jgenapplmicrobiol",
  "jgenmicrobiol",
  "jhazardmater",
  "jheattransfer",
  "jheterocyclchem",
  "jhighresolutchromatogr",
  "jhistochemcytochem",
  "jhydrol",
  "jhypertens",
  "jimagingscitechnol",
  "jinclusionphenommolrecognitchem",
  "jindengchem",
  "jindianchemsoc",
  "jindmicrobiol",
  "jindmicrobiolbiotechnol",
  "jinorgbiochem",
  "jinorgnuclchem",
  "jinorgorganometpolym",
  "jinstchem",
  "jinstenvironsci",
  "jinstwaterenvironmanage",
  "jintellmatersyststruct",
  "jinterferoncytokineres",
  "jinterferonres",
  "jjpninstmet",
  "jkoreanchemsoc",
  "jlabelledcompdradiopharm",
  "jlipidmediators",
  "jlipidmediatorscellsignalling",
  "jlipidres",
  "jliqchromatogr",
  "jliqchromatogrrelatedtechnol",
  "jlowtempphys",
  "jlumin",
  "jmacromolsciphys",
  "jmacromolscipureapplchem",
  "jmacromolscirevmacromolchemphys",
  "jmagnmagnmater",
  "jmagnresonsera",
  "jmagnresonserb",
  "jmassspectrom",
  "jmaterchem",
  "jmaterchema",
  "jmaterchemb",
  "jmaterchemc",
  "jmaterciveng",
  "jmatercycleswastemanage",
  "jmaterengperform",
  "jmaterprocessmanufsci",
  "jmaterprocesstech",
  "jmaterprocesstechnol",
  "jmaterres",
  "jmaterscilett",
  "jmaterscimaterelectron",
  "jmaterscimatermed",
  "jmaterscitechnol",
  "jmatersynthprocess",
  "jmathchem",
  "jmechbehavbiomedmater",
  "jmedchem",
  "jmembrbiol",
  "jmembrsci",
  "jmicrobiolbiotechnol",
  "jmicrobiolmethods",
  "jmicrocolumnsep",
  "jmicroencapsulation",
  "jmolbiol",
  "jmolcatal",
  "jmolcatalachem",
  "jmolcatalbenzym",
  "jmolliq",
  "jmolmicrobiolbiotechnol",
  "jmolmodel",
  "jmolspectrosc",
  "jmolstruct",
  "jnatgasscieng",
  "jnatprod",
  "jneurochem",
  "jneurosci",
  "jneuroscires",
  "jnewmaterelectrochemsyst",
  "jnoncrystsolids",
  "jnuclmater",
  "jnuclscitechnol",
  "jom",
  "joptsocamboptphys",
  "jorganometchem",
  "jorgchem",
  "joule",
  "jpcjplanarchromatogrmodtlc",
  "jpetscitechnol",
  "jpharmacolexpther",
  "jpharmacoltoxicolmethods",
  "jpharmbiomedanal",
  "jpharmpharmacol",
  "jpharmsci",
  "jphaseequilib",
  "jphotochemphotobiola",
  "jphotochemphotobiolb",
  "jphotochemphotobiolcphotochemrev",
  "jphotopolymscitechnol",
  "jphysamathgen",
  "jphysbatmoloptphys",
  "jphyschem",
  "jphyschema",
  "jphyschemb",
  "jphyschemc",
  "jphyschemlett",
  "jphyschemrefdata",
  "jphyschemsolids",
  "jphyscondensmatter",
  "jphysdapplphys",
  "jphysgnuclpartphys",
  "jphysi",
  "jphysii",
  "jphysiii",
  "jphysiv",
  "jphysorgchem",
  "jphyssocjpn",
  "jplanarchromatogrmodtlc",
  "jplantbiochembiotechnol",
  "jpnjapplphyspart",
  "jpnjcancerres",
  "jpnjpharmacol",
  "jpnjtoxicolenvironhealth",
  "jpolymeng",
  "jpolymmater",
  "jpolymsciapolymchem",
  "jpolymscipartapolymchem",
  "jpolymscipartbpolymphys",
  "jporousmater",
  "jporphyrinsphthalocyanines",
  "jporphyrphthalocyanines",
  "jpowersources",
  "jpraktchemchemztg",
  "jpropulpower",
  "jproteinchem",
  "jpulppapsci",
  "jquantspectroscradiattransfer",
  "jradioanalnuclchem",
  "jradioanalnuclchemart",
  "jradioanalnuclchemlett",
  "jramanspectrosc",
  "jreinfplastcompos",
  "jrheol",
  "jsafrinstminmetall",
  "jscifoodagric",
  "jsciindres",
  "jsmeintjsera",
  "jsmeintjserb",
  "jsmeintjserc",
  "jsolgelscitechnol",
  "jsolidstatechem",
  "jsolidstateelectrochem",
  "jsolutionchem",
  "jsteroidbiochemmolbiol",
  "jstrainanalengdes",
  "jstructchem",
  "jsupercritfluids",
  "jsynthorgchemjpn",
  "jtaiwaninstcheme",
  "jtesteval",
  "jthermanal",
  "jthermanalcalorim",
  "jthermophysheattransfer",
  "jthermoplastcomposmater",
  "jthermspraytechnol",
  "jtoxicolclintoxicol",
  "jtoxicolcutaneousocultoxicol",
  "jtoxicolenvironhealth",
  "jtoxicoltoxinrev",
  "jtraceelemexpmed",
  "jtraceelemmedbiol",
  "jtracemicroprobetech",
  "jvacscitechnola",
  "jvacscitechnolb",
  "jwoodchemtechnol",
  "kautschgummikunstst",
  "keyengmater",
  "khimfiz",
  "kinetcatal",
  "kinetkatal",
  "kolloidnzh",
  "koordkhim",
  "koreanjchemeng",
  "kovovemater",
  "labautominfmanage",
  "labchip",
  "labinvest",
  "labrobautom",
  "landdegraddev",
  "langmuir",
  "laserchem",
  "lcgc",
  "lettapplmicrobiol",
  "liebigsannchem",
  "liebigsannrecl",
  "lifesci",
  "liqcryst",
  "lwtfoodscitechnol",
  "macromolchemphys",
  "macromolecules",
  "macromolrapidcommun",
  "macromolsymp",
  "macromoltheorysimul",
  "magnresonchem",
  "magykemfoly",
  "maingroupmetchem",
  "manufchem",
  "marchem",
  "marenvironres",
  "marpollutbull",
  "massspectromrev",
  "matercharact",
  "materchemfront",
  "materchemphys",
  "matercorros",
  "materdes",
  "matereval",
  "materforum",
  "materhightemp",
  "materhoriz",
  "materialwisswerkstofftech",
  "materlett",
  "matermanufprocesses",
  "materperformance",
  "materresbull",
  "materresinnovations",
  "matersci",
  "materscienga",
  "matersciengb",
  "matersciengc",
  "matersciengr",
  "matersciengrrep",
  "matersciforum",
  "matersciresint",
  "materscisemicondprocess",
  "materscitechnol",
  "materstruct",
  "matertoday",
  "matertransjim",
  "measscitechnol",
  "meatsci",
  "mechcomposmater",
  "mechcomposmaterstruct",
  "mechmater",
  "medchemcommun",
  "medchemres",
  "mendeleevcommun",
  "metallmatertransa",
  "metallmatertransb",
  "metallomics",
  "metallovedtermobrabmet",
  "metalltransa",
  "metalltransb",
  "methodsbiochemanal",
  "methodsenzymol",
  "metionsbiolsyst",
  "metsciheattreat",
  "microbiolres",
  "microchemj",
  "microchimacta",
  "microelectroneng",
  "microelectronj",
  "micropormesopormater",
  "microporousmater",
  "microporousmesoporousmater",
  "microscalethermophyseng",
  "mikrochimacta",
  "minereng",
  "minermetallprocess",
  "minerprocessextrmetallrev",
  "modellsimulmaterscieng",
  "modphysletta",
  "modphyslettb",
  "molbiosyst",
  "molcancerther",
  "molcatal",
  "molcellbiochem",
  "molcrystliqcrystscitechnolsecta",
  "molcrystliqcrystscitechnolsectc",
  "molmarbiolbiotech",
  "molmicrobiol",
  "molnutrfoodres",
  "molpharmaceutics",
  "molpharmacol",
  "molphys",
  "molreproddev",
  "molsystdeseng",
  "monatshchem",
  "monnotrastronsoc",
  "mrsbull",
  "mrsinternetjnitridesemicondres",
  "nachrchemtechlab",
  "nanoenergy",
  "nanolett",
  "nanomednanotechbiolmed",
  "nanomicrolett",
  "nanores",
  "nanoscale",
  "nanoscalehoriz",
  "nanostructmater",
  "nanotoday",
  "nanotoxicology",
  "natbiotechnol",
  "natcatal",
  "natchem",
  "natchembiol",
  "natcommun",
  "natenergy",
  "natlscirev",
  "natmater",
  "natmed",
  "natmethods",
  "natnanotech",
  "natoasisersera",
  "natoasiserserb",
  "natoasiserserc",
  "natoasisersere",
  "natoasiserserg",
  "natoasiserserh",
  "natphoton",
  "natprodlett",
  "natprodrep",
  "natprotoc",
  "natrevchem",
  "natrevdrugdisc",
  "natrevmater",
  "natstructbiol",
  "nature",
  "naunynschmiedebergsarchpharmacol",
  "ndtandeint",
  "neftkhoz",
  "neorgmater",
  "neurochemint",
  "neurochemres",
  "newcomprbiochem",
  "newjchem",
  "newpolymmat",
  "npgasiamater",
  "npjcomputmater",
  "npjdmaterappl",
  "npjflexelectron",
  "npjmaterdegrad",
  "npjscifood",
  "nucleicacidsres",
  "nuclengdes",
  "nuclfusion",
  "nuclinstrummethodsphysressecta",
  "nuclinstrummethodsphysressectb",
  "nuclphysa",
  "nuclphysb",
  "nucltechnol",
  "numerheattransferparta",
  "numerheattransferpartb",
  "nuovocimentosocitalfisa",
  "nuovocimentosocitalfisb",
  "nuovocimentosocitalfisc",
  "nuovocimentosocitalfisd",
  "oilgasj",
  "optcommun",
  "optlett",
  "optmater",
  "optspektrosk",
  "optzh",
  "organohalogencompd",
  "organometallics",
  "orgbiomolchem",
  "orgchemfront",
  "orgelectron",
  "orggeochem",
  "orglett",
  "orgmassspectrom",
  "orgprepprocedint",
  "orgprocessresdev",
  "orgreactmech",
  "originslifeevolbiosphere",
  "oxidmet",
  "ozonescieng",
  "particuology",
  "partpartsystchar",
  "partscitechnol",
  "pccp",
  "petscitechnol",
  "pharmacolrev",
  "pharmacoltherapeut",
  "phasetransitions",
  "philosmaga",
  "philosmagb",
  "philosmaglett",
  "philostransrsoclondonsera",
  "philostransrsoclondonserb",
  "phosphorussulfursiliconrelatelem",
  "photochemphotobiol",
  "photochemphotobiolsci",
  "photosynthres",
  "physchemchemphys",
  "physchemglasses",
  "physchemliq",
  "physchemminer",
  "physfluidsa",
  "physfluidsb",
  "physicaa",
  "physicab",
  "physicac",
  "physicad",
  "physicae",
  "physiolchemphysmednmr",
  "physiolplant",
  "physletta",
  "physlettb",
  "physliferev",
  "physrevaatmoloptphys",
  "physrevbcondensmatter",
  "physrevcnuclphys",
  "physrevdpartfields",
  "physrevestatphysplasmasfluids",
  "physrevlett",
  "physscr",
  "physstatussolidia",
  "physstatussolidib",
  "phytochemanal",
  "plantamed",
  "plantphysiolbiochem",
  "plasmachemplasmaprocess",
  "plasmaphyscontrolledfusion",
  "plasmasourcesscitechnol",
  "plasteng",
  "plastrubbercomposprocessappl",
  "platsurffinish",
  "plosone",
  "pnas",
  "poljchem",
  "polymadvtechnol",
  "polymbull",
  "polymchem",
  "polymcompos",
  "polymdegradstab",
  "polymdegradstabil",
  "polymengsci",
  "polymer",
  "polymgelsnetworks",
  "polymint",
  "polymj",
  "polymmaterscieng",
  "polymnetworksblends",
  "polymplasttechnoleng",
  "polymprepramchemsocdivpolymchem",
  "polymreacteng",
  "polymrecycl",
  "polymrev",
  "polymtest",
  "powderdiffr",
  "powdermetall",
  "powdermetallmetceram",
  "powdertechnol",
  "prepbiochembiotech",
  "prepramchemsocdivpetchem",
  "preprpapamchemsocdivfuelchem",
  "proccombustinst",
  "processbiochem",
  "processcontrolqual",
  "processsafenvironprot",
  "processsafprog",
  "procrsoclondonsera",
  "procrsoclondonserb",
  "progbiophysmolbiol",
  "progchemorgnatprod",
  "progcolloidpolymsci",
  "progcrystgrowthcharactmater",
  "progcrystgrowthchmater",
  "progenergycombustsci",
  "progheterocyclchem",
  "proginorgchem",
  "proglipidres",
  "progmatersci",
  "prognuclmagnresonspectrosc",
  "progorgcoat",
  "progphotovoltaics",
  "progpolymsci",
  "progreactkinet",
  "progsolidstatechem",
  "progsurfsci",
  "proteineng",
  "proteinsci",
  "protmet",
  "przemchem",
  "pureapplchem",
  "quantstructactrelat",
  "quimanalbarcelona",
  "radiateffdefectssolids",
  "radiatphyschem",
  "radiatprotdosim",
  "radiatres",
  "radiochimacta",
  "rapidcommunmassspectrom",
  "reactchemeng",
  "reactfunctpolym",
  "reactkinetcatallett",
  "recltravchimpaysbas",
  "refractindceram",
  "regultoxicolpharm",
  "remotesensenviron",
  "renewenergy",
  "renewsustenergrev",
  "renewsustenergyrev",
  "reschemintermed",
  "rescommunmolpatholpharmacol",
  "revanalchem",
  "revchemeng",
  "revchim",
  "revcomputchem",
  "revenvironcontamtoxicol",
  "revgentherm",
  "revmetallcahinftech",
  "revphysiolbiochempharmacol",
  "revroumchim",
  "revsciinstrum",
  "rheolacta",
  "rscadv",
  "rubberchemtechnol",
  "russchembull",
  "russjapplchem",
  "russjcoordchem",
  "russjelectrochem",
  "russjgenchem",
  "russjorgchem",
  "russmetall",
  "safrjchem",
  "sampej",
  "scandjmetall",
  "sciadv",
  "scibull",
  "scichinaserb",
  "scichinasere",
  "science",
  "sciprog",
  "scirep",
  "scitechnolweldjoining",
  "scitotalenviron",
  "scitranslmed",
  "scriptamater",
  "scrmater",
  "semicondscitechnol",
  "sensactuatorsa",
  "sensactuatorsb",
  "sensactuatorsbchem",
  "seppurifmethods",
  "seppuriftechnol",
  "sepscitechnol",
  "silicindus",
  "small",
  "smallmethods",
  "smartmaterstruct",
  "softmatter",
  "soilbiolbiochem",
  "solarprl",
  "solenergy",
  "solenergymatersolcells",
  "solidstatecommun",
  "solidstateelectron",
  "solidstateionics",
  "solidstatenuclmagnreson",
  "solventextrionexch",
  "spectrochimacta",
  "spectrochimactaamolbiomolspectrosc",
  "spectrochimactaparta",
  "spectrochimactapartb",
  "spectrosceur",
  "spectrosclett",
  "spectroscpropinorgorganometcompd",
  "speculationsscitechnol",
  "spillscitechnolbull",
  "springerserchemphys",
  "springersersolidstatesci",
  "structbond",
  "structchem",
  "studnatprodchem",
  "studsurfscicatal",
  "supercondscitechnol",
  "superlatticesmicrostruct",
  "supramolchem",
  "supramolsci",
  "surfcoatint",
  "surfcoattechnol",
  "surfinterfaceanal",
  "surfrevlett",
  "surfsci",
  "surfscirep",
  "surfscispectra",
  "sustainableenergyfuels",
  "synlett",
  "synthcommun",
  "synthesis",
  "synthmet",
  "synthreactinorgmetorgchem",
  "talanta",
  "tappij",
  "tetrahedron",
  "tetrahedronasymmetry",
  "tetrahedronlett",
  "theochem",
  "theorchemacc",
  "theorexpchem",
  "theorfoundchemeng",
  "theranostics",
  "thermochimacta",
  "thinsolidfilms",
  "tissueeng",
  "topapplphys",
  "topbiolinorgchem",
  "topcatal",
  "topcurrchem",
  "topinorgchem",
  "toxicolapplpharmacol",
  "toxicolenvironchem",
  "toxicollett",
  "toxicolsci",
  "traceelemelectrolytes",
  "tractrendsanalchem",
  "transinstmetfinish",
  "transinstminmetallsecta",
  "transinstminmetallsectb",
  "transinstminmetallsectc",
  "transitionmetchem",
  "trendsanalchem",
  "trendsbiochemsci",
  "trendsbiotechnol",
  "trendsfoodscitech",
  "tsvetnmetmoscow",
  "ukrfizzh",
  "ukrkhimzh",
  "ultrasonsonochem",
  "uspkhim",
  "vibspectrosc",
  "wastemanageoxford",
  "wastemanageres",
  "waterairsoilpollut",
  "waterenvironres",
  "waterres",
  "waterresourres",
  "waterscitechnol",
  "wirescomputmolsci",
  "worldjmicrobiolbiotechnol",
  "xrayspectrom",
  "zanorgallgchem",
  "zhfizkhim",
  "zhneorgkhim",
  "zhobshchkhim",
  "zhorgkhim",
  "zhpriklkhim",
  "zkristallogr",
  "zkristallogrnewcryststruct",
  "zmetailkd",
  "znaturforschaphyssci",
  "znaturforschbchemsci",
  "znaturforschcbiosci",
  "zphysahadronsnucl",
  "zphysbcondensmatter",
  "zphyschem",
  "zphyscpartfields",
  "zphysdatmolclusters"
];

export const JOURNAL_DATA_ALL: IJournalData = ABBREVIATIONS_ALL.reduce(
  (obj: IJournalData, ab) => {
    obj[ab] = {
      canAchieve: JOURNAL_DATA[ab] ? JOURNAL_DATA[ab].canAchieve : false,
      full: ""
    };
    return obj;
  },
  {}
);



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/constants/journal.ts